module.exports = __webpack_public_path__ + "img/air_green.8403a9aa.svg";